import React from 'react'

export default function RawMarkup(props) {
    var rawMarkup = props.content
    
    return (
        <span dangerouslySetInnerHTML={{ __html: rawMarkup }} />
    );
}